// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"282":"bf8ca779","323":"cdbf8ca1","366":"d7dfdafa","600":"5a952434","671":"40dd860e"}[chunkId] + ".chunk.css";
};